module.exports = __webpack_public_path__ + "static/img/r_024.d32f184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_024.jpg
// module id = CV3p
// module chunks = 1